export class ItemSaldoPorVencer {
    fecha;
    institucion_financiera;
    total_por_vencer;
    por_vencer_1_30_dias;
    por_vencer_1_3_meses;
    por_vencer_3_6_meses;
    por_vencer_6_12_meses;
    por_vencer_mas_12_meses;
    constructor() {
        this.fecha = "";
        this.institucion_financiera = "";
        this.total_por_vencer = 0;
        this.por_vencer_1_30_dias = 0;
        this.por_vencer_1_3_meses = 0;
        this.por_vencer_3_6_meses = 0;
        this.por_vencer_6_12_meses = 0;
        this.por_vencer_mas_12_meses = 0;
    }
}
